module.exports = __webpack_public_path__ + "static/media/5b151a8b.jpg";